import {
	inject, ref, type Ref, 
} from "vue";

import { AircraftClassKey } from "@/symbols";

export const useAircraftClass = () => {
	const aircraftClass = inject<Ref<"Fixed-wing" | "Rotor-wing" | string | null>>(AircraftClassKey, ref(null));
	return aircraftClass;
};